import { defineStore } from "pinia";
import TicketRepository from "@/repositories/Api/TicketRepository";
import ChatMeRoomRepository from "@/repositories/Api/ChatMeRoomRepository";
import { v4 as uuidv4 } from "uuid";
import CustomerProfileRepository from "@/repositories/Api/CustomerProfileRepository";

// import axios from 'axios'

const useTicketStore = defineStore("ticket", {
  state: () => ({
    tickets: [],
    ticketTotal: 0,
    ticketsHistory: [],
    ticketsChatMeHistory: [],
    ticketMessagesTotal: 0,
    ticketMessages: [],
    ticketMessagesRef: [],
    stackIndex: 0,
    selectedTicket: {},
    selectedTicketCustomer: {},
    selectedTicketDetail: {},
    selectedChatMeTicketDetail: {},
    isRichText: false,
    getAsyncOptions: {
      order: "createdAt", // option : asc & desc
      sort: "desc", // option : asc & desc
      page: 1,
      limit: 20,
      filter: "",
      search: "",
      status: "",
      operatorAssigned: "",
    },
    getAsyncMessageOption: {
      order: "createdAt",
      // sort: 'asc',
      // option : asc & desc
      page: 1,
      limit: 10,
      filter: "",
    },
    loading: {
      isFetchingTickets: false,
      isFetchingMessage: false,
      isUpdating: false,
      isSubmitting: false,
      isDeleting: false,
      isSending: false,
      isFetching: false,
      isFetchingMoreTicket: false,
      isFetchingMoreChat: false,
      isNewMessageAdd: false,
      isUpdateSocketData: true,
    },
    options: {
      priority: [],
      assignee: [],
    },
    editableStatue: {
      isEditableName: false,
      isEditableEmail: false,
      isEditablePhone: false,
    },
    toggleLeftSidebar: true,
    toggleRightSidebar: false,
  }),
  getters: {
    getTickets(state) {
      return state.tickets;
    },
    getSelectedTicket(state) {
      return state.selectedTicket;
    },
    getTicketHistory(state) {
      return state.ticketsHistory;
    },
    getSelectedTicketDetail(state) {
      return state.selectedTicketDetail;
    },
    getSelectedTicketDetailHeader(state) {
      return {
        ticketNum: state.selectedTicketDetail.ticketNum,
        id: state.selectedTicketDetail.id,
        title: state.selectedTicketDetail.title,
        createdAt: state.selectedTicketDetail.createdAt,
      };
    },
    getSelectedTicketDetailAssign(state) {
      try {
        return {
          assignName: `${state.selectedTicketDetail.assignee.firstName} ${state.selectedTicketDetail.assignee.lastName}`,
          assignId: state.selectedTicketDetail.assignee.id,
          status: state.selectedTicketDetail.status,
          priorityLevel: state.selectedTicketDetail.priorityLevel,
        };
      } catch (error) {
        return {
          status: state.selectedTicketDetail.status,
          priorityLevel: state.selectedTicketDetail.priorityLevel,
        };
      }
    },
    getSelectedTicketDetailCustomerID(state) {
      return state.selectedTicketDetail?.customer?.id;
    },
    isTicketSelected(state) {
      return Object.keys(state.selectedTicket).length > 0;
    },
    getLoadingState(state) {
      return state.loading;
    },
    getOptions(state) {
      return state.options;
    },
    getTicketListHistory(state) {
      return state.ticketsHistory;
    },
    getTicketMessages(state) {
      return state.ticketMessages;
    },
    getSelectedTicketStatus(state) {
      return state.selectedTicketDetail.status;
    },
    getSelectedTicketInternalNote(state) {
      return state.selectedTicketDetail.internalNote;
    },
    getOperatorOption(state) {
      return state.selectedTicketDetail.option;
    },

    //chat-me
    getSelectedTicketDetailRoomId(state) {
      return state.selectedTicketDetail?.chatMeRoomId;
    },
    isChatMeTicket(state) {
      return state.selectedTicketDetail?.isPrivateChat;
    },
    getChatMeTicketHistory(state) {
      return state.ticketsChatMeHistory;
    },

    //end chat-me
  },
  actions: {
    setToggleRightSidebar(value) {
      if (value !== undefined) this.toggleRightSidebar = value;
      else this.toggleRightSidebar = !this.toggleRightSidebar;
    },
    setToggleLeftSidebar(value) {
      if (value !== undefined) this.toggleLeftSidebar = value;
      else this.toggleLeftSidebar = !this.toggleLeftSidebar;
    },
    // Sync Actions
    resetTicketMessageParamsOption() {
      // this.getAsyncOptions.page = 1
      this.getAsyncMessageOption.page = 1;
      // console.log('Reset Message\'s Param', this.getAsyncMessageOption.page)
    },

    resetCustomerEditorProfile() {
      this.editableStatue.isEditableName = false;
      this.editableStatue.isEditableEmail = false;
      this.editableStatue.isEditablePhone = false;
    },

    resetTicketParamsOption() {
      // this.getAsyncOptions.page = 1
      this.getAsyncOptions.page = 1;
      // console.log('Reset Message\'s Param', this.getAsyncMessageOption.page)
    },

    setSelectedTicket(ticket) {
      this.selectedTicket = ticket;
      this.selectedTicketDetail = ticket;
    },

    findTicketById(ticketId) {
      // return this.tickets.find(ticket => ticket.id === ticketId)
    },

    setAsyncFilterOptions(type, operatorId) {
      if (type === "resolved") {
        // this.getAsyncOptions.operatorAssigned = 'unassigned'
        this.getAsyncOptions.operatorAssigned = "";
        this.getAsyncOptions.status = 2;
      } else if (type === "unassigned") {
        this.getAsyncOptions.operatorAssigned = "unassigned";
        this.getAsyncOptions.status = "";
      } else if (type === "mine") {
        this.getAsyncOptions.operatorAssigned = operatorId;
        this.getAsyncOptions.status = "";
      } else {
        this.getAsyncOptions.operatorAssigned = "";
        this.getAsyncOptions.status = "";
      }
    },
    // region Ticket Action 🎫
    addTicketToList(ticket) {
      // console.log('add new ticket to list')
      this.ticketsTotal += 1;
      // this.tickets.unshift(ticket)
      this.tickets = [ticket, ...this.tickets];
    },

    addMoreTicketToList(tickets) {
      // console.log(this.tickets.concat(tickets))
      // this.tickets = this.tickets.concat(tickets)
      this.tickets = [...this.tickets, ...tickets];
      // console.log(this.tickets)
    },

    addMoreMessageToList(messages) {
      this.ticketMessages = [...this.ticketMessages, ...messages];
      // console.log(this.ticketMessages)
    },

    addNewTicketToHistory(ticket) {
      this.ticketsHistory = [ticket, ...this.ticketsHistory];
    },

    removeTicketFromList(ticketId) {
      // this.loading.isUpdateSocketData = false
      this.ticketsTotal -= 1;
      this.tickets = this.tickets.filter((ticket) => ticket.id !== ticketId);
      // this.loading.isUpdateSocketData = true
    },

    updateTicketOnList(ticketId, payload) {
      this.loading.isUpdateSocketData = false;
      const ticketIndex = this.tickets.findIndex(
        (ticket) => ticket.id === ticketId
      );
      this.tickets[ticketIndex] = { ...this.tickets[ticketIndex], ...payload };
      // console.log('update ticket on list', this.tickets[ticketIndex])
      this.loading.isUpdateSocketData = true;
    },
    updateVisitorProfileOnTicketList(payload) {
      const ticketIndex = this.tickets.findIndex(
        (ticket) => ticket.id === this.selectedTicket.id
      );
      this.tickets[ticketIndex] = {
        ...this.tickets[ticketIndex],
        customer: { ...payload },
      };
    },

    updateSelectedTicket(payload) {
      // console.log('🍍 Update Select Ticket UI ', payload)
      this.selectedTicketDetail = { ...this.selectedTicketDetail, ...payload };
    },

    checkExistingMessage(incomingMessageId) {
      return this.ticketMessages.findIndex(
        (message) => message.id === incomingMessageId
      );
    },

    async getTicketsAsync() {
      this.loading.isFetchingTickets = true;
      try {
        const response = await TicketRepository.getTickets(
          this.getAsyncOptions
        );

        // json server
        // const response = await axios.get('http://localhost:3000/ticket')
        const data = response.data.data.list;
        // console.log('[getTicketsAsync] 🍍 success', data)
        //  console.log("adsfasrgfaewrg wertw");
        this.tickets = data;
        this.ticketTotal = response.data.data.total;
        this.loading.isFetchingTickets = false;
        // console.log("this.selectedTicket.id", this.selectedTicketDetail);
        const selectedTicket = data.find(
          (val) => val.id == this.selectedTicketDetail.id
        );
        // console.log("selectedTicket===", selectedTicket);
      } catch (e) {
        // console.log('[getTicketsAsync] 🍍 error', e)
        this.tickets = [];
        this.loading.isFetchingTickets = false;
      }
    },

    async getTicketByIdAsync(ticketId) {
      const hasTicket = this.tickets.find((ticket) => ticket.id === ticketId);

      if (!hasTicket) return {};

      // this.loading.isFetchingTickets = true
      try {
        const res = await TicketRepository.getTicketById(ticketId);
        // console.log('getTicketByIdAsync>>',res)
        return res.data.data;

        // json server
        // const response = await axios.get('http://localhost:3000/ticket')
        // const data = response.data.data.list
        // console.log('[getTicketsAsync] 🍍 success', data)
        // this.tickets = data
        // this.ticketTotal = response.data.data.total
        // this.loading.isFetchingTickets = false
      } catch (e) {
        // console.log(e)
        return {};
        // console.log('[getTicketsAsync] 🍍 error', e)
        // this.tickets = []
        // this.loading.isFetchingTickets = false
      }
    },
    async getTicketsInfiniteAsync() {
      this.loading.isFetchingMoreTicket = true;
      try {
        // const newLimit = this.getAsyncOptions.limit + 20
        this.getAsyncOptions.page += 1;
        const response = await TicketRepository.getTickets({
          ...this.getAsyncOptions,
        });
        const data = response.data.data.list;
        // console.log('[getTicketsInfiniteAsync] 🍍🍍', data.length)

        // data.foreach(each => this.tickets.push(each))
        // console.log('[getTicketsInfiniteAsync] 🚀', this.tickets)
        this.ticketsTotal += data.length;
        this.addMoreTicketToList(data);
        this.loading.isFetchingMoreTicket = false;
      } catch (e) {
        // console.log('[getTicketsInfiniteAsync] 🍍🍍', e)
        this.loading.isFetchingMoreTicket = false;
      }
    },

    async getTicketListHistoryAsync() {
      // console.log('🚀', this.selectedTicketDetail.customer.id)
      try {
        const res = await TicketRepository.getTicketsHistory(
          this.selectedTicketDetail.customer.id
        );
        this.ticketsHistory = res.data.data.list;
      } catch (e) {
        this.ticketsHistory = [];
      }
    },

    async getTicketListHistoryByIdAsync(id) {
      // console.log('🚀', this.selectedTicketDetail.customer.id)
      try {
        const res = await TicketRepository.getTicketsHistory(id);
        return res.data.data.list;
      } catch (e) {
        // console.log(e)
        return [];
      }
    },

    async createTicketAsync(payload, customerId) {
      this.loading.isSubmitting = true;
      try {
        const dataform = {
          ...payload,
          customerId,
        };
        // console.log(dataform)
        const response = await TicketRepository.createTicket(dataform);
        const { data } = response.data;
        // console.log('Respond Ticket Create', data)
        // this.addNewTicketToHistory(data)
        // this.addTicketToList(data)
        this.loading.isSubmitting = false;
        return true;
      } catch (e) {
        // console.log(e)
        this.loading.isSubmitting = false;
        return false;
        // return {}
      }
    },

    async updateTicketAsync(payload) {
      this.loading.isUpdating = true;
      try {
        // console.log(this.selectedTicket.id, payload)
        const response = await TicketRepository.updateTicket(
          this.selectedTicket.id,
          payload
        );
        // console.log('ticket Update', response.data.data)
        // this.updateTicketOnList(this.selectedTicket.id, response.data.data)
        // this.updateSelectedTicket(response.data.data)

        if (payload.priorityLevel) {
          this.selectedTicketDetail.priorityLevel = payload.priorityLevel
        }

        this.loading.isUpdating = false;
      } catch (e) {
        this.loading.isUpdating = false;
      }
    },
    async updateTicketLastSeenAsync(payload) {
      this.loading.isUpdating = true;

      if (this.selectedTicket.id !== "123") {
        return;
      }
      try {
        // console.log(this.selectedTicket.id, payload)
        const response = await TicketRepository.updateTicket(
          this.selectedTicket.id,
          payload
        );
        // console.log('ticket Update', response.data.data)
        this.updateTicketOnList(this.selectedTicket.id, response.data.data);
        this.updateSelectedTicket(response.data.data);
        this.loading.isUpdating = false;
      } catch (e) {
        this.loading.isUpdating = false;
      }
    },

    async deleteTicketAsync() {
      this.loading.isDeleting = true;
      try {
        const response = await TicketRepository.deletedTicket(
          this.selectedTicket.id
        );
        // console.log('ticket Delete', response)
        this.loading.isDeleting = false;
        this.toggleRightSidebar = false;
        this.removeTicketFromList(this.selectedTicket.id);
        this.selectedTicket = {};
        this.selectedTicketDetail = {};
      } catch (e) {
        this.loading.isDeleting = false;
      }
    },

    // endregion

    addMessageToList(message) {
      this.ticketMessages.unshift(message);
      this.ticketMessagesTotal += 1;
    },

    updateMessageSentStatus(refId) {
      // First index is
      const messageBoxIndexByUiId = this.ticketMessages.findIndex(
        (message) => message.ref === refId
      );
      this.ticketMessages[messageBoxIndexByUiId].isSending = false;
      // console.log('update 🎬', this.ticketMessages[messageBoxIndexByUiId])
    },

    // removeMessageSentStatus(uiId, payload) {
    //   // First index is
    //   const messageBoxIndexByUiId = this.ticketMessages.findIndex(message => message.uiId === uiId)
    //   this.ticketMessages[messageBoxIndexByUiId].isSending = payload.isSending
    //   this.ticketMessages[messageBoxIndexByUiId].id = payload.id
    // console.log('update 🎬', this.ticketMessages[messageBoxIndexByUiId])
    // },

    async getTicketMessageAsync() {
      this.loading.isFetching = true;
      this.loading.isFetchingMessage = true;
      try {
        if (!this.selectedTicket.id) return;

        const response = await TicketRepository.getTicketMessageById(
          this.selectedTicket.id,
          { ...this.getAsyncMessageOption }
        );
        const { list } = response.data.data;
        this.loading.isFetchingMessage = false;
        this.loading.isFetching = false;
        this.ticketMessagesTotal = response.data.data.total;
        this.ticketMessages = list;
      } catch (e) {
        this.loading.isFetchingMessage = false;
        this.loading.isFetching = false;
        this.ticketMessages = [];
      }
    },

    async getTicketMessageInfiniteAsync() {
      this.loading.isFetching = true;
      this.getAsyncMessageOption.page += 1;
      try {
        if (!this.selectedTicket.id) return;

        const response = await TicketRepository.getTicketMessageById(
          this.selectedTicket.id,
          { ...this.getAsyncMessageOption }
        );

        const { list } = response.data.data;

        // console.log('[getTicketMessage] 🍍🍍', list)
        this.loading.isFetching = false;
        // this.ticketMessagesTotal += list.length
        // console.log('message length', list.length)
        // console.log(this.ticketMessagesTotal)
        this.addMoreMessageToList(list);
      } catch (e) {
        // console.log('[getTicketMessage] 🍍🍍', e)
        this.loading.isFetching = false;
        this.ticketMessages = [];
      }
    },

    async createTicketMessageAsync(payload) {
      this.loading.isSending = true;
      const uiId = uuidv4();

      // const uiId = this.stackIndex
      // this.stackIndex += 1
      // This data add to ticket message list immediately after send message, and update with real data after received successful respond from server
      // console.log('payload', payload)
      const placeholderData = {
        id: "",
        ref: uiId,
        message: payload.message,
        isSending: true,
        createdAt: new Date().toISOString(),
        participant: {
          name: payload.operatorName,
          participantType: "operator",
        },
      };
      this.addMessageToList(placeholderData);

      try {
        this.ticketMessagesRef.push(uiId);
        const response = await TicketRepository.createTicketMessage({
          message: payload.message,
          ticketId: this.selectedTicket.id,
          ref: uiId,
        });
        const { data } = response.data;
        this.loading.isNewMessageAdded = true;
        this.loading.isNewMessageAdded = false;
        // console.log('🍍🥦 Create New Message Successfully', data)
        // this.addMessageToList(data)
        // this.updateMessageSentStatus(uiId, { isSending: false, id: data.id })
        this.loading.isSending = false;
      } catch (e) {
        // console.log('🍍🥦 Create New Message fail 💀', e)
        this.loading.isSending = false;
      }
    },

    // region Creates Option
    async getCreateTicketOptionAsync() {
      try {
        const responseAssign = await TicketRepository.getTicketAssignOption();
        const respondPriority =
          await TicketRepository.getTicketPriorityOption();

        // const responseAssign = await axios.get('http://localhost:3000/assign')
        // const respondPriority = await axios.get('http://localhost:3000/levels')

        const AssignData = responseAssign.data.data;
        const PriorityData = respondPriority.data.data;

        // console.log('update', AssignData)
        // console.log('update', PriorityData)

        const RefactorPriorityData = Object.entries(PriorityData).map(
          (each) => ({
            value: each[1],
            // text: i18n.tc(`ticket.${each[0].toLowerCase()}`),
            text: `ticket.${each[0].toLowerCase()}`,
          })
        );

        const RefactorOperatorData = AssignData.map((each) => ({
          value: each.id,
          text: `${each.firstName} ${each.lastName}`,
        }));

        RefactorOperatorData.unshift({
          value: "",
          // text: i18n.tc('ticket.unassigned'),
          text: "ticket.unassigned",
        });

        // console.log('update', RefactorOperatorData)
        // console.log('update ', RefactorPriorityData)

        this.options.assignee = RefactorOperatorData;
        this.options.priority = RefactorPriorityData;
      } catch (e) {
        this.options.assignee = [{ value: "", text: "Network Error ⛔️" }];
        this.options.priority = [{ value: "", text: "Network Error ⛔️" }];
      }
    },
    // endregion

    async getTicketCustomerProfile() {
      try {
        if (!this.selectedTicket.customerId) return;

        const response = await CustomerProfileRepository.getProfile(
          this.selectedTicket.customerId
        );
        const { data } = response.data;
        this.selectedTicketCustomer = data;
        // console.log('🤼 customer profile', data)
      } catch (e) {
        this.selectedTicketCustomer = {};
        // console.log('🤼 customer profile', e)
      }
    },

    //chatMe
    async getChatMeTicketListHistoryAsync() {
      // console.log('🚀', this.selectedTicketDetail.customer.id)
      try {
        if(this.selectedChatMeTicketDetail?.chatMeRoomId){
          const res = await TicketRepository.getChatMeTicketsHistory(
            this.selectedChatMeTicketDetail.chatMeRoomId
          );
          this.ticketsChatMeHistory = res.data.data;
        }
      } catch (e) {
        this.ticketsChatMeHistory = [];
      }
    },

    getChatMeRoomInfo(chatMeRoomId, userId) {
      ChatMeRoomRepository.getRoomInfoById(chatMeRoomId).then((response) => {
        const roomInfo = response?.data?.data;
        if (roomInfo) {
          const nameRoom = roomInfo.members;

          const filterRoom = nameRoom.filter(
            (user) => user?.meta?.id && user?.meta?.merchantUserId !== userId
          );

          const renameRoom = filterRoom
            .map((user) => user.meta.name)
            .join(" - ");

          this.selectedChatMeTicketDetail = { ...roomInfo, renameRoom, filterRoom };
        }
      });
    },
  },
});
export default useTicketStore;
